module.exports = __webpack_public_path__ + "assets/img/1141587020900_.pic_hd.e0167712.jpg";